"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require(36);
function willDestroy(fn) {
    return create_1.create({
        willDestroy: function () {
            fn(this.props, this.providers);
        },
    });
}
exports.willDestroy = willDestroy;
//# sourceMappingURL=willDestroy.js.map